import { Ac, NonAc, Seater, Sleeper, Volvo, Evening, Afternoon, Morning } from './icons/svg';

export const apiUrl = {
    // GET ? fromCityID | toCityID | fromCityName | toCityName | journeyDate | mode
    search: '/api/resource/searchRoutesV4',
    // GET ? tripId | chartDate | fromCity | toCity
    track: '/api/others/GetGPSLocationURL',
    // GET ? routeID
    routeInfo: '/api/resource/getRouteInfo',
    // GET ? routeID | journeyDate
    chart: '/api/resource/seatArrangement',
    // POST
    orderSave: '/api/expco/ordersave',
    // GET ? token
    orderDetails: '/api/expco/getOrderDetails',
    // GET ? RouteCode | SeatLabel_ | Gender_
    genderValidate: '/api/resource/APIGenderValidate',
    // GET ? RouteCode | MobileNumber | EmailID | CouponName
    couponList: '/api/resource/APICouponCardListAll',
    // GET ? RouteCode | MobileNumber | Email | CouponName | OpDiscount | TotalFare | CouponName2 | CouponName3 | IsLoggedin | ServiceCharge | Stax
    //couponRedeem: '/api/resource/APIRedeemCouponv4',
    couponRedeem: '/api/resource/APIRedeemCouponv5',
    // GET ? RouteCode | MobileNumber | OTP | CouponName | OpDiscount | TotalFare | CouponName2 | CouponName3 | ServiceCharge | Stax
    couponValidate: '/api/resource/APIvalidateCouponOTPV4',
    // GET ? mobile | prepaid_no
    prepaidDetails: '/api/others/prepaid_card_details',
    // POST
    prepaidSave: '/api/expco/prepaidCardOrderSave',
    // GET ? mobile | otptype=PD
    generateOTP: '/api/resource/GenerateOTP',
    // GET ? OTP | otptype=PD
    validateOTP: '/api/resource/APIValidateAgentOTPLogin',
    saveProfile: '/my_profile/saveProfile',
    //GET ? RouteCode
    middlecities: "/api/resource/ActiveMiddleCities",
    //GET ? agent_id or msurl  any of them
    ismantispg: "/api/resource/ismantispg",
    //GET ? mobile_number , siteurl if needed
    getlogintoken: "/api/resource/APIGetlogintoken",
    //POST
    waitlist: "/api/others/paxWaitList"
}

export const color = {
    primary: window.color.searchBoxBgColor || '#0089CF',
    secondary: window.color.buttonColor || '#F15A22',
    couponBackground: window.color.offerBoxBgColor || '#FCFBB7'
}

export const Rs = window.location.hostname === 'busdemo.travels.com.mm' ? 'K' : window.location.hostname === 'easybuscoach.buscrs.com' ? '/=' : window.msurl === 'shwesanthu.com' ? 'Ks' : window.msurl === 'moventis.iamgds.com' ? "SAR ": '₹';

export const bustypeFilter = [
    {
        name: 'AC',
        svg: Ac
    },
    {
        name: 'Non AC',
        svg: NonAc
    },
    {
        name: 'Seater',
        svg: Seater
    },
    {
        name: 'Sleeper',
        svg: Sleeper
    }
];

export const timeFilter = [
    {
        name: 'Morning',
        time: '00:00 - 12:00',
        svg: Morning
    },
    {
        name: 'Afternoon',
        time: '12:00 - 18:00',
        svg: Afternoon
    },
    {
        name: 'Evening',
        time: '18:00 - 00:00',
        svg: Evening
    }
];


// WEBPACK FOOTER //
// ./src/components/common/constants.js